export let propertyObject={
    title: '',
    description: '',
    discountPrice: '',
    price: '',
    floor: '',
    area: '',
    amenities: [],
    images: [],
    serverImages: [], 

    images360: '',
    threeDModels: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    latitude: '',
    longitude: '',
    numberOfBedrooms: '',
    numberOfBathrooms: '',
    constructionYear: '',
    agentName: '',
    agentPhone: '',
    agentEmail: '',
    nearbyPlaces: [],
    availableQuantity: '',
    totalQuantity: '',
    builtInArea:'',
    brochure:''    
}